{
  "name": "fe-service-configurator",
  "version": "0.2.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:staging": "ng build --configuration=staging",
    "build:integration": "ng build --configuration=integration",
    "build:prod": "ng build --configuration=production --aot",
    "test": "npm run lint && npm run prettier",
    "lint": "tsc --noEmit && eslint .",
    "prettier": "prettier -c src",
    "serve": "node node_modules/http-server/bin/http-server -c-1 -p 4200 dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "19.2.14",
    "@angular/cdk": "19.2.19",
    "@angular/common": "19.2.14",
    "@angular/compiler": "19.2.14",
    "@angular/core": "19.2.14",
    "@angular/flex-layout": "15.0.0-beta.42",
    "@angular/forms": "19.2.14",
    "@angular/material": "19.2.19",
    "@angular/material-moment-adapter": "19.2.19",
    "@angular/platform-browser": "19.2.14",
    "@angular/platform-browser-dynamic": "19.2.14",
    "@angular/router": "19.2.14",
    "@angular/service-worker": "19.2.14",
    "@everest/codestyle": "2.0.1",
    "@ngx-translate/core": "16.0.4",
    "@ngx-translate/http-loader": "16.0.1",
    "@vi-succ/design-system-web": "1.4.2",
    "@vi/global-header": "15.3.3",
    "@vi/quest": "15.5.1",
    "angular2-recaptcha": "1.1.0",
    "bootstrap": "4.6.2",
    "deepmerge-ts": "7.1.5",
    "lodash": "4.17.21",
    "moment": "2.30.1",
    "ng-recaptcha": "13.2.1",
    "ngx-skeleton-loader": "11.3.0",
    "ngx-translate-multi-http-loader": "17.0.0",
    "ngx-uploader": "16.0.0",
    "rxjs": "7.8.2",
    "tslib": "2.8.1",
    "underscore": "1.13.7",
    "uuid": "12.0.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.15",
    "@angular-eslint/builder": "19.8.1",
    "@angular-eslint/eslint-plugin": "19.8.1",
    "@angular-eslint/eslint-plugin-template": "19.8.1",
    "@angular-eslint/schematics": "19.8.1",
    "@angular-eslint/template-parser": "19.8.1",
    "@angular/cli": "19.2.15",
    "@angular/compiler-cli": "19.2.14",
    "@angular/language-service": "19.2.14",
    "@everest/eslint-config": "1.3.2",
    "@types/ineum": "216.0.4",
    "@types/lodash": "4.17.20",
    "@types/node": "24.3.1",
    "@types/uuid": "10.0.0",
    "@typescript-eslint/eslint-plugin": "8.42.0",
    "@typescript-eslint/parser": "8.42.0",
    "codelyzer": "6.0.2",
    "eslint": "8.57.1",
    "eslint-config-prettier": "9.1.2",
    "eslint-plugin-prettier": "5.5.4",
    "http-server": "14.1.1",
    "prettier": "2.8.8",
    "protractor": "7.0.0",
    "ts-node": "10.9.2",
    "tslint": "6.1.3",
    "tslint-config-prettier": "1.18.0",
    "typescript": "5.8.3"
  },
  "optionalDependencies": {
    "fsevents": "2.3.3"
  },
  "packageManager": "yarn@4.9.4"
}
